define('views/components/transaction/transaction',['require','backbone','text!templates/components/transaction/transaction.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/transaction/transaction.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'transaction-item',

        initialize: function () {
            if (this.model.get('status') === 0) {
                if(this.model.get('is_recurring')){
                    this.$el.addClass('bg-orange');
                }else{
                    this.$el.addClass('bg-success-light');
                }
            }
        }
    });
});
